export default "__VITE_ASSET__nLJiUJ2K__"